import React, { useState, useEffect, useRef } from 'react';
import './index.scss';
import setting from 'asset/img/setting.png';
import title from 'asset/img/title-person.png';
import back from 'asset/img/back.png';
import avator from 'asset/img/avator.webp';
import background from 'asset/img/bk-person.webp';
import { useNavigate } from 'react-router-dom';
import white from 'asset/img/white.webp';
import gold from 'asset/img/gold.webp';
import { useSelector, useDispatch } from 'react-redux';
import { formatTimeHM, formatDateY } from 'utils';
import { message } from 'antd';
import { getUserInfo } from 'network';
import { setUser } from 'actions';

const PersonCenter = () => {
    const [data, setData] = useState({});
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.user);

    // 进入页时拉取最新用户信息并更新 Redux，避免金币等显示滞后（如抽奖/闯关后未刷新）
    useEffect(() => {
        getUserInfo({}).then((res) => {
            if (res?.data) dispatch(setUser(res.data));
        }).catch(() => {});
    }, [dispatch]);

    const handleBack = () => {
        navigate(`/home`);
    };

    const gotoEdit = () => {
        navigate(`/personCenterEdit`);
    }

    const invite = () => {
        message.info('功能尚未开放');
    }

    return (
        <div className='personCenter-container'>
            <img src={background} className='white' alt="" />
            <img src={white} className='white' alt="" />
            <div className='pet-back' onClick={handleBack}><img src={back} alt="返回" /></div>
            <div className='pet-edit' onClick={gotoEdit}><img src={setting} alt="设置" /></div>
            <div className='personCenter-content'>
                <div className='personCenter-title'><img src={title} /></div>
                <div className='personCenter-person'>
                    <div className='person-left'>
                        <div className='avator'>
                            <img src={user?.avatar || avator} alt="头像" onError={(e) => { e.target.src = avator; }} />
                        </div>
                        <div className='profile'>
                            <div className='vip'>vip</div>
                            <div className='name'>
                                {user?.name}
                            </div>
                            <div className='phone'>{user?.mobile}</div>
                        </div>
                    </div>
                    <div className='person-right'>
                        <div className='score-value'>{user?.total_score || 0}</div>
                        <div className='score-label'>总积分</div>
                    </div>
                </div>
                <div className='personCenter-record'>
                    <div className='item'>
                        <div className='content'>{user?.today_done_count}</div>
                        <div className='name'>{'今日闯关'}</div>
                    </div>
                    <div className='item'>
                        <div className='content'>{formatTimeHM(user?.total_sec)}</div>
                        <div className='name'>{'学习总时长'}</div>
                    </div>
                    <div className='item'>
                        <div className='content'>{user?.total_done_count}</div>
                        <div className='name'>{'总闯关数'}</div>
                    </div>
                </div>
                <div className='personCenter-vip'>
                    <div className='vip'>vip 会员</div>
                    {/* <div className='time'>到期时间：{formatDateY(data?.vip_expire)}</div> */}
                    <div className='time'>
                        到期时间：
                        {user?.vip_expire == 1 ? (
                            <span className='non-member'>非会员</span>
                        ) : user?.vip_expire == 0 || user?.vip_expire == 111 ? (
                            <span className='permanent-member'>永久会员</span>
                        ) : (
                            <span>{formatDateY(user?.vip_expire)}</span>
                        )}
                    </div>
                </div>
                <div className='personCenter-checkin' onClick={() => navigate('/checkin')}>
                    <div className='font'>
                        <div className='title'>每日签到</div>
                        <div className='sub'>打卡领金币，解锁荣誉</div>
                    </div>
                    <span className='arrow'>›</span>
                </div>
                {/* 育儿顾问：已隐藏，恢复展示金币和邀请 */}
                {/* <div className='personCenter-parenthelp' onClick={() => navigate('/parentHelp')}>
                    <div className='font'>
                        <div className='title'>育儿顾问</div>
                        <div className='sub'>视频解答，陪伴成长</div>
                    </div>
                    <span className='arrow'>›</span>
                </div> */}
                <div className='personCenter-bottom'>
                    <div className='left' onClick={invite}>
                        <div className='font'>
                            <div className='title'>一起学习</div>
                            <div>邀请好友</div>
                        </div>
                        <div className='image'></div>
                    </div>
                    <div className='right'>
                        <div className='font'>
                            <div className='title'>我的金币</div>
                            <div className='value'>{user?.coin_remain}</div>
                        </div>
                        <div className='image'>
                            <img src={gold} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonCenter;